export const ProfileSliderTypes = {
    MY_PROFILE: "MyProfileSlider",
    LOGIN_SETTINGS: "LoginSettingsSlider"
}
